import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState, useEffect, useContext, useCallback } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import classnames from "classnames";
import styles from "@/styles/Breadcrumbs.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};

IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
export var BreadcrumbsContext = /*#__PURE__*/React.createContext({
  breadcrumbs: [],
  setBreadcrumbs: function setBreadcrumbs() {
    return null;
  }
});
BreadcrumbsContext.displayName = "BreadcrumbsContext";
export function BreadcrumbsProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      breadcrumbs = _useState[0],
      setBreadcrumbs = _useState[1];

  var router = useRouter();
  var timeoutId = useRef();
  var setBreadcrumbsLazy = useCallback(function (value) {
    timeoutId.current = setTimeout(function () {
      setBreadcrumbs(value);
    }, 10);
  }, []);
  useEffect(function () {
    var handleHistoryChange = function handleHistoryChange() {
      setBreadcrumbs([]);
    };

    router.events.on("routeChangeComplete", handleHistoryChange);
    return function () {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }

      router.events.off("routeChangeComplete", handleHistoryChange);
    };
  }, []);
  var contextValue = {
    breadcrumbs: breadcrumbs,
    setBreadcrumbs: setBreadcrumbsLazy
  };
  return /*#__PURE__*/_jsx(BreadcrumbsContext.Provider, {
    value: contextValue,
    children: children
  });
}

function Breadcrumbs(_ref2) {
  var hidden = _ref2.hidden,
      mobile = _ref2.mobile;
  if (hidden) return null;

  var _useContext = useContext(BreadcrumbsContext),
      breadcrumbs = _useContext.breadcrumbs;

  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.breadcrumbs, _defineProperty({}, styles.mobile, mobile)),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.inner,
      children: breadcrumbs.map(function (breadcrumb, i) {
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [breadcrumb.href && /*#__PURE__*/_jsx(Link, {
            href: breadcrumb.href,
            children: /*#__PURE__*/_jsx("a", {
              className: styles.link,
              children: /*#__PURE__*/_jsx("span", {
                title: breadcrumb.text,
                children: breadcrumb.text
              })
            })
          }), !breadcrumb.href && /*#__PURE__*/_jsx("span", {
            className: styles.link,
            title: breadcrumb.text,
            children: breadcrumb.text
          }), breadcrumbs.length != i + 1 && /*#__PURE__*/_jsx("span", {
            className: styles.arrow,
            children: /*#__PURE__*/_jsx(IconArrow, {})
          })]
        }, "breadcrumbs-".concat(i));
      })
    })
  });
}

export default /*#__PURE__*/React.memo(Breadcrumbs);
export var BreadcrumbsForFooter = function BreadcrumbsForFooter() {
  var _useContext2 = useContext(BreadcrumbsContext),
      breadcrumbs = _useContext2.breadcrumbs;

  var hidden = breadcrumbs.length == 0;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.footerBreadcrumbs, _defineProperty({}, styles.hidden, hidden)),
    children: /*#__PURE__*/_jsx(Breadcrumbs, {
      mobile: true,
      hidden: hidden
    })
  });
};